var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "section",
    { staticClass: "w-full" },
    [
      _c(
        "LoadingOverlay",
        {
          attrs: {
            hasData: _vm.hasData,
            loading: _vm.loading,
            spinnerCentered: "",
          },
        },
        [
          _c(
            "p",
            { staticClass: "font-semibold w-max-content custom-title mt-1" },
            [_vm._v("Marketplace")]
          ),
          _c("p", { staticClass: "marketText" }, [
            _vm._v(
              " Welcome to the ProveraCare Marketplace! Feel free to browse and add new resources to your internal "
            ),
            _c("br"),
            _vm._v(
              " Talent Directory, custom-tailoring a resource library that perfectly suits your company's needs. "
            ),
          ]),
          _c("MarketplaceFilters", {
            attrs: { filters: _vm.marketplaceFilters },
            on: {
              filtersChanged: _vm.updateFilters,
              resetFilters: _vm.resetFilters,
            },
          }),
          _c("ActionPanel", {
            staticClass: "mb-6",
            attrs: {
              total: _vm.getActiveNumber,
              pageName: "Active Resources in Marketplace",
            },
          }),
          _vm.emptyList
            ? _c("EmptyListPlaceholder", {
                attrs: { title: _vm.emptyListPlaceholder },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "image",
                      fn: function () {
                        return [_c("EmptyListImageMarketplace")]
                      },
                      proxy: true,
                    },
                  ],
                  null,
                  false,
                  1447469600
                ),
              })
            : _c(
                "div",
                [
                  _c("ElementsSizeProvider", {
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function ({ setSize, getBlockMinHeight }) {
                          return [
                            _c(
                              "div",
                              { staticClass: "flex flex-wrap gap-4 topScroll" },
                              _vm._l(
                                _vm.marketplaceUsers,
                                function (marketplaceUser, index) {
                                  return _c("MarketplaceCard", {
                                    key: marketplaceUser.id,
                                    attrs: {
                                      hasAllResourceAccess:
                                        _vm.hasAllResourceAccess,
                                      marketplaceUser: marketplaceUser,
                                      company: _vm.company,
                                      currentUser: _vm.currentUser,
                                      nameBlockMinHeight: getBlockMinHeight({
                                        id: marketplaceUser.id,
                                        blockName: "name",
                                        index,
                                      }),
                                      skillsBlockMinHeight: getBlockMinHeight({
                                        id: marketplaceUser.id,
                                        blockName: "skills",
                                        index,
                                      }),
                                    },
                                    on: {
                                      "update:nameBlockMinHeight": (
                                        minHeight
                                      ) =>
                                        setSize({
                                          id: marketplaceUser.id,
                                          blockName: "name",
                                          minHeight,
                                          index,
                                        }),
                                      "update:skillsBlockMinHeight": (
                                        minHeight
                                      ) =>
                                        setSize({
                                          id: marketplaceUser.id,
                                          blockName: "skills",
                                          minHeight,
                                          index,
                                        }),
                                      cardDataUpdated: _vm.refetchCollection,
                                    },
                                  })
                                }
                              ),
                              1
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("CardPagination", {
                    attrs: { config: _vm.paginationConfig },
                    on: {
                      "update:config": function ($event) {
                        _vm.paginationConfig = $event
                      },
                    },
                  }),
                ],
                1
              ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }